'use strict';
var React = require('react');
var Components = require('./Components.jsx');
var pageHelper = require('./../../helper/pageHelper.js');

var FullPage = React.createClass({
  propTypes: {
    page: React.PropTypes.object.isRequired,
    pageDidLoad: React.PropTypes.func.isRequired,
    fullPageLocation: React.PropTypes.object,
  },
  componentDidMount: function () {
    var offset = $('.full-page').offset();
    this.props.pageDidLoad(offset);
  },
  shouldComponentUpdate: function (nextProps, nextState) {
    var oldLocation = nextProps.fullPageLocation;
    var newLocation = $('.full-page').offset();
    //终止update死循环
    if (oldLocation.left === newLocation.left
      && oldLocation.top === newLocation.top) {
      return false;
    }
    return true;
  },
  componentDidUpdate: function () {
    var offset = $('.full-page').offset();
    this.props.pageDidLoad(offset);
  },

  render: function () {
    var page = JSON.parse(JSON.stringify(this.props.page));
    var backgroundColor = page.param[0].backgroundColor;
    var components = page.controls.control || [];
    //批注里面过滤掉不可使组件
    for(var i = components.length - 1;i >= 0; i--) {
      if(pageHelper.IsInvisualInteractiveCom(components[i].controlTypeID)) {
        components.splice(i,1);
      }
    }
    return (
      <div className="full-page" style={{
        width: page.measureW,
        height: page.measureH,
        background: backgroundColor
      }}>
        <Components components={components}/>
      </div>
    );
  }
});

module.exports = FullPage;



// WEBPACK FOOTER //
// ./src/views/Page/FullPage.jsx